import { useMemo } from "react";
import { object, bool, number } from "prop-types";
import { observer } from "mobx-react";
import { MinAvgMaxKeys } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { BufferTooltipContent } from "./components";

export const BreakdownPriceBufferTooltip = observer(({
  element,
  cleanValue,
  isMax
}) => {
  const structure = useEstimateStructure();
  const { maxValuesAsBuffer } = structure.settings;
  
  const displayTwoValues = element.displayTotalTwoValues;
  
  const valueKey = useMemo(() => {
    if(maxValuesAsBuffer)
      return MinAvgMaxKeys.AVG;
    if(isMax)
      return MinAvgMaxKeys.MAX;
    
    return displayTwoValues ? MinAvgMaxKeys.MIN : MinAvgMaxKeys.AVG;
  }, [isMax, displayTwoValues, maxValuesAsBuffer])
  
  const bufferedValues = element.getAllBufferedPrices(valueKey);
  
  return <BufferTooltipContent
    isPrice
    cleanValue={cleanValue}
    bufferedValues={bufferedValues}
  />
});

BreakdownPriceBufferTooltip.propTypes = {
  element: object.isRequired,
  cleanValue: number.isRequired,
  isMax: bool,
}